import React, { Component } from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { Row, Col } from "styled-bootstrap-grid";
import Footer from "../../../Shared/Footer";
import { saveTechnicianWorkHours } from "../../../../Actions/TechnicianTimesheet";
import { userDataTech, fetchLocalData } from "../../../../Actions/UserTechData";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import { logoutUser } from "../../../../Actions";
class TimesheetEntry extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nextButton: false,
      time4time: false,
      paymentType: undefined,
    };
    this.goToCallout = true;
    this.commingPage = this.props.location.state
      ? this.props.location.state.page
      : "";
  }

  boxClick = (paymentType) => {
    this.setState({
      paymentType,
    });
  };

  componentDidMount() {
    this.goToCallout =
      this.props.saveData.isCallOutOrRoadside === "Y" &&
      this.commingPage === "additionalHours";
    if (Object.keys(this.props.saveData).length === 0) {
      this.props.dispatch(fetchLocalData());
      // this.props.history.push("hourslogin");
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.saveMessage !== void 0 &&
      this.props.saveMessage.type === "Timesheet Saved Successfully" &&
      this.props.saveMessage.message.errorCd === "SUCCESS"
    ) {
      let payload = {
        technicianId: this.props.ssoId,
        branchId: this.props.branchId,
        clckInOut: "OUT",
        reasonCd: "43",
        signedInBy: null,
        signedOutBy: this.props.ssoId,
        comments: null,
      };
      this.props.dispatch(logoutUser(payload));
    }
    if (prevProps !== this.props) {
      if (this.props.saveData === null) {
        this.props.history.push("hourslogin");
      }
    }
  }
  goback = () => {
    this.props.dispatch(userDataTech({}));
    this.props.history.push("hourslogin");
  };

  prepareData = () => {
    let data = {};

    data = Object.assign(data, this.props.saveData);
    if (this.commingPage === "additionalHours") {
      data.paymentType = this.state.paymentType;
    } else {
      if (data.callOuts.length > 0) {
        data.callOuts.forEach((callout) => {
          callout.paymentType = this.state.paymentType;
        });
      }
    }
    return data;
  };

  nextStep = () => {
    let data = this.prepareData();
    this.props.dispatch(userDataTech(data));
    this.props.history.push("callouts");
  };

  submit = () => {
    let data = this.prepareData();
    data.actualPaidBreakHours = data.timesheetActualPaidBreakHours;
    delete data["timesheetActualPaidBreakHours"];
    delete data["timesheetPaidBreakHours"];
    this.props.dispatch(saveTechnicianWorkHours(data));
  };

  render() {
    const { paymentType } = this.state;

    return this.props.saveData !== void 0 ? (
      <Wrapper>
        <P>
          <Trans>indicateIfTheseHoursAreOnTimeForTimeOrYouExpecting</Trans>
        </P>
        <Handler>
          <Row className="rowCenter">
            <Col sm="3" />
            {this.props.security && this.props.security.timeForTime === "Y" && (
              <Col sm="2">
                <Div
                  time4time={paymentType === "T"}
                  onClick={() => this.boxClick("T")}
                >
                  <Trans>timeForTime</Trans>
                </Div>
              </Col>
            )}
            <Col sm="2">
              <Div
                paymentHours={paymentType === "P"}
                onClick={() => this.boxClick("P")}
              >
                <Trans>payment</Trans>
              </Div>
            </Col>
            {this.props.security && this.props.security.timeForTime === "B" && (
              <Col sm="2">
                <Div
                  paymentHours={paymentType === "B"}
                  onClick={() => this.boxClick("B")}
                >
                  <Trans>paymentTimeForTime</Trans>
                </Div>
              </Col>
            )}
            <Col sm="3" />
          </Row>
        </Handler>
        <Footer>
          <BackButton onClick={this.goback}>
            <Trans>back</Trans>
          </BackButton>
          {this.goToCallout ? (
            <ButtonSubmit
              active={paymentType}
              onClick={paymentType ? this.nextStep : null}
            >
              <Trans>next</Trans>
            </ButtonSubmit>
          ) : (
            <ButtonSubmit active={paymentType} onClick={this.submit}>
              <Trans>submitAndLogout</Trans>
            </ButtonSubmit>
          )}
        </Footer>
      </Wrapper>
    ) : (
      <div />
    );
  }
}

const mapStateToProps = ({
  auth,
  userMessage,
  userTechData,
  technicianTimesheet,
  saveTechnicianTimesheet,
  fetchTimesheetSecurity,
}) => {
  return {
    message: userMessage,
    saveData: userTechData.payload,
    techData: technicianTimesheet.payload,
    branchId: auth.user ? auth.user.defaultProfile.branchId : null,
    ssoId: auth.ssoId,
    saveMessage: saveTechnicianTimesheet,
    security: fetchTimesheetSecurity.securityList,
  };
};

export default withRouter(
  connect(mapStateToProps)(withTranslation()(TimesheetEntry))
);

const Div = styled.div`
  border-radius: 3px;
  height: 100px;
  max-width: 120%;
  width: 170px;
  background: #f1f4f9;
  box-shadow: 2px 2px #0000000d;
  padding-top: 35px;
  border: 1px solid #0000001a;
  cursor: pointer;
  overflow: hidden;
  display: inline-block;
  ${({ time4time, paymentHours }) =>
    (time4time || paymentHours) &&
    `
    background: #00BFFF;
    color: #FFFFFF;
  `}
`;
const ButtonSubmit = styled.button`
  background: ${(props) => (props.active ? "#c4151c" : "#e1e5eb")};
  border-radius: 30px;
  padding: 0;
  border: ${(props) => (props.active ? "none" : "1px solid #96989a")};
  height: 34px;
  width: 129px;
  color: ${(props) => (props.active ? "#ffffff" : "#939292")};
  font-weight: 50;
  position: relative;
  left: 40px;
  font-size: 12px;
`;
const BackButton = styled.button`
  border: 2px solid #e0e0e0;
  width: 130px;
  height: 35px;
  border-radius: 50px;
  background: #ffffff;
  color: #434f5b;
  font-size: 12px;
`;
const Wrapper = styled.div`
  font-family: Trebuchet MS;
  overflow: hidden;
  color: #4a4a4a;
  .rowCenter {
    justify-content: center;
  }
`;
const Handler = styled.div`
  position: relative;
`;
const P = styled.p`
  margin-top: 4%;
  //
`;
